<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title *ngIf="product">
            {{product.title}}
            <p class="subtitle">Sub products</p>
        </ion-title>
    </ion-toolbar>

</ion-header>

<ion-content>

    <div class="sub-product-wrapper">
        <ion-list *ngIf="sub_products">
            <ion-item *ngFor="let sub_product of sub_products" detail="true" button="true" (click)="subProductClicked(sub_product)" lines="full">
                <ion-label>
                    <h3>
                        <ng-container *ngFor="let variation of sub_product.variations; let i = index;">{{variation.title}}: {{variation.attribute.title}}<span *ngIf="i+1 < sub_product.variations.length"> / </span></ng-container>
                    </h3>
                    <ion-grid class="ion-no-padding">
                        <ion-row *ngIf="(sub_product.sku && show_sku == true) || sub_product.sell_price || sub_product.track_stock">
                            <ion-col *ngIf="sub_product.sku && show_sku == true" size="auto">
                                <h5>SKU</h5>
                                <p class="prominent">{{sub_product.sku}}</p>
                            </ion-col>
                            <ion-col *ngIf="sub_product.sell_price" size="auto">
                                <h5>Price</h5>
                                <p class="prominent">{{cart.currency.sign}}{{sub_product.sell_price | number:'1.2'}}<ng-container *ngIf="sub_product.has_contract_price"> (contract price)</ng-container></p>
                            </ion-col>
                            <ion-col *ngIf="sub_product.track_stock" size="auto">
                                <h5>Available</h5>
                                <p class="prominent">
                                    <span *ngIf="sub_product.available_stock > sub_product.low_available_stock_level" class="success">{{sub_product.available_stock}}</span>
                                    <span *ngIf="sub_product.available_stock <= sub_product.low_available_stock_level && sub_product.available_stock > 0" class="warning">{{sub_product.available_stock}}</span>
                                    <span *ngIf="sub_product.track_stock && sub_product.available_stock <= 0" class="danger">{{sub_product.available_stock}}</span>
                                </p>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </ion-label>
            </ion-item>
        </ion-list>
    </div>

    <ion-grid *ngIf="sub_products && sub_products.length == 0" class="nothing-found">
        <ion-row class="ion-align-items-center ion-justify-content-center">
            <ion-col>
                <p>
                    <fa-icon [icon]="['fal', 'cube']" size="6x"></fa-icon>
                    <span>No sub products found</span>
                </p>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>